import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import LoadingCircle from "../../../../components/loadingCircle/LoadingCircle";
import useNavigateTo from "../../../../hooks/useNavigateTo";
import { DeliveryCount } from "../../../../models/deliveryCount";
import { TagName } from "../../../../models/tag";
import YourDeliveriesCards from "../../components/yourDeliveriesCards/YourDeliveriesCards";
import YourDeliveriesHeadline from "../../components/yourDeliveriesHeadline/YourDeliveriesHeadline";
import "./YourDeliveriesSection.scss";

interface YourDeliveriesSectionProps {
  deliveryCount: DeliveryCount[];
  loading: boolean;
}

const YourDeliveriesSection = (props: YourDeliveriesSectionProps) => {
  const { t } = useTranslation();
  const { navigateToDeliveries } = useNavigateTo();
  const { deliveryCount, loading } = props;

  const allDeliveriesCount =
    deliveryCount.find((count) => count.key === TagName.AllDeliveries)?.value ||
    0;

  return (
    <div data-testid="your-deliveries-section" className="section-container">
      <div className="section-container-headline">
        <YourDeliveriesHeadline count={allDeliveriesCount} />
      </div>
      <YourDeliveriesCards deliveryCount={deliveryCount} loading={loading} />
      <div className="section-container-button">
        <Button variant="contained" onClick={() => navigateToDeliveries()}>
          <div className="section-container-button-text">
            {t("allDeliveries")}
          </div>
          {loading ? (
            <LoadingCircle />
          ) : (
            <div className="section-container-button-count">
              {allDeliveriesCount}
            </div>
          )}
        </Button>
      </div>
    </div>
  );
};

export default YourDeliveriesSection;
